import { AuthenticatedService } from "../abstract/base.service";
import { EditUserTypeMetadataGroupsConfigurationCommand } from "@/server/app.commands";
import { GetUserTypeMetadataGroupsConfigurationDtoQuery } from "@/server/app.queries";
import { MetadataConfiguration } from "@/server/app.dtos";

export const UserTypesEndpoint = `api/usertypes`;

export class UserTypesService extends AuthenticatedService {
  ChangeMetadataGroups(
    command: EditUserTypeMetadataGroupsConfigurationCommand
  ): Promise<number> {
    return this.Put<number>(
      `${this.baseUrl}${UserTypesEndpoint}/metadatagroupsconfig`,
      command
    );
  }

  GetMetadataGroupsConfiguration(
    query: GetUserTypeMetadataGroupsConfigurationDtoQuery
  ): Promise<MetadataConfiguration> {
    return this.Get<MetadataConfiguration>(
      `${
        this.baseUrl
      }${UserTypesEndpoint}/metadatagroupsconfig?${this.GetQueryStringByObject(
        query
      )}`
    );
  }
}
